import { canUseDOM } from 'exenv';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { formatMsShort } from '../../../../../../../shared/frontend/libs/utils';
import CountdownTimer from '../../../../../../../shared/frontend/components/presentational/countdownTimer';
import { useAllDungeons, useSiteConfig } from '../../../../../../../shared/frontend/scripts/selectors/global';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import { TSeasonDef } from '../../../../../../../shared/gameConfig/mythicPlus';

export type TCountdownPaneProps = {
  bgImagePath: string;
  locString: string;
  targetDate: string;
};

export function SeasonCountdownPane({ season, index }: { season: TSeasonDef; index: number }) {
  const dungeons = useAllDungeons();
  const { seed } = useSiteConfig();
  const bgImagePath = useMemo(() => {
    const seasonDungeons = season.allowedDungeons
      ? dungeons.filter((d) => season.allowedDungeons!.includes(d.id))
      : dungeons;
    if (!seasonDungeons.length) {
      return '/images/dungeons/expansion10/base/the-stonevault.jpg';
    }
    const dungeon = seasonDungeons[(seed + index) % seasonDungeons.length];
    return `/images/dungeons/expansion${dungeon.expansion_id}/base/${dungeon.slug}.jpg`;
  }, [dungeons, season, seed, index]);

  return (
    <CountdownPane bgImagePath={bgImagePath} locString="frontpage:season-unlocks-in" targetDate={season.starts.us.format()} />
  );
}

export function CountdownPane(props: TCountdownPaneProps) {
  return (
    <div
      className="slds-grid slds-grid--vertical-align-center rio-background--header rio-border--dark"
      style={{
        borderRadius: '0.25rem',
        minHeight: 200,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${asset(props.bgImagePath)})`,
        backgroundPosition: 'center center'
      }}
    >
      <div className="slds-col rio-text--title slds-text-heading--large rio-text-shadow--normal slds-text-align--center text-bold">
        <Trans i18nKey={props.locString}>
          <CountdownTimer
            style={{ display: 'inline-block' }}
            to={props.targetDate}
            formatter={formatMsShort}
            onComplete={
              canUseDOM
                ? window.location.reload.bind(window.location)
                : () => {
                    /* nop */
                  }
            }
          />
        </Trans>
      </div>
    </div>
  );
}
